import { Alert, Button, Col, Input, Row, Select, Typography } from "antd";
import React, { useEffect, useState } from "react";
import {
  ADD_LOCATION,
  API_BASE_URL,
  directToken,
  LIST_OF_CITY,
  LIST_OF_HOSPITAL,
} from "../services/end_points";
import axios from "axios";

const AddArea = ({ updateUserList }) => {
  const [alert, setAlert] = useState();
  const [addcity, setAddcity] = useState(false);
  const [cityOption, setCityOption] = useState();

  const [formdata, setFormdata] = useState({
    hospitalId: "",
    city: "",
    area: "",
  });
  const [hospitalOption, setHospitalOption] = useState();
  const userId = localStorage.getItem("userid");
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,

      [name]: value,
    }));
  };
  useEffect(() => {
    getHospital();
    getCity();
  }, []);
  const getHospital = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        { headers }
      );
      const data = await response.json();
      setHospitalOption(
        data.list.map((source) => ({
          label: source.hospitalName,
          value: source.id,
        }))
      );
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}${ADD_LOCATION}`, formdata)
      .then((res) => {
        setFormdata({
          hospitalId: "",
          city: "",
          area: "",
        });
        updateUserList(res.data);
        if (res.status == 201) {
          setAlert(true);
        } // Reset formdata after successful submission
      })
      .catch((err) => {
        console.error(err);
        setAlert(false);
      });
  };

  //   const handleAddcity = () => {
  //     if (addcity) {
  //       setAddcity(false);
  //       return;
  //     } else {
  //       setAddcity(true);
  //       return;
  //     }
  //   };
  const getCity = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_CITY}`, {
        headers,
      });
      const data = await response.json();
      setCityOption(
        data.list.map((source) => ({ label: source.city, value: source.id }))
      );
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  return (
    <>
      <div>
        {alert && (
          <div marginBottom="20px">
            <Alert
              // type="success"
              style={{
                backgroundColor: "#dff0d8",
                color: "green",
                fontSize: "16px",
                borderColor: "#dff0d8",
                textAlign: "center",
              }}
              message={"Location Created!"}
            />
          </div>
        )}
      </div>
      <div>
        <Row>
          <Col xl={24} md={16} lg={20} sm={24}>
            <Row
              gutter={[16, 16]} // Adds spacing between rows and columns
              style={{ marginTop: "20px" }}
            >
              <Col xl={8} md={24} sm={24}>
                <Typography style={{ fontWeight: 550, marginLeft: "15px" }}>
                  Select City
                </Typography>
                <Select
                  showSearch
                  style={{ width: "100%", height: "40px", minWidth: "150px" }}
                  name="city"
                  value={formdata.city || undefined}
                  onChange={(value) =>
                    setFormdata({ ...formdata, city: value })
                  }
                  options={cityOption}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  dropdownStyle={{
                    maxHeight: "200px", // Set the max height for the dropdown
                    overflowY: "auto", // Enable vertical scrolling
                  }}
                  dropdownRender={(menu) => <div>{menu}</div>}
                />
              </Col>

              <Col xl={8} md={24} sm={24}>
                <Typography style={{ fontWeight: 550, marginLeft: "15px" }}>
                  Area
                </Typography>
                <Input
                  required
                  id="Area"
                  name="area"
                  value={formdata.area}
                  onChange={handleFormChange}
                  style={{
                    height: "40px",
                    fontSize: "14px",
                    width: "100%",
                    minWidth: "150px",
                  }}
                />
              </Col>
              <Col xl={8} md={24} sm={24}>
                <Typography style={{ fontWeight: 550, marginLeft: "15px" }}>
                  Select Hospital
                </Typography>
                <Select
                  showSearch
                  style={{ width: "100%", height: "40px", minWidth: "150px" }}
                  name="hospitalId"
                  value={formdata.hospitalId || undefined}
                  onChange={(value) =>
                    setFormdata({ ...formdata, hospitalId: value })
                  }
                  options={hospitalOption}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  dropdownStyle={{
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                  dropdownRender={(menu) => <div>{menu}</div>}
                />
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
              }}
            >
              <Button
                type="button"
                onClick={() =>
                  setFormdata({ city: "", area: "", hospitalId: "" })
                }
                style={{
                  color: "black",
                  border: "solid #1236fa",
                  marginRight: "auto",
                  width: "85px",
                  height: "32px",
                  borderRadius: "3vw",
                }}
              >
                Reset
              </Button>
              <Button
                type="submit"
                onClick={handleSubmit}
                style={{
                  color: "white",
                  background: "#1236fa",
                  width: "85px",
                  height: "32px",
                  borderRadius: "3vw",
                }}
              >
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default AddArea;
